module.exports = __webpack_public_path__ + "4ab6ecc1e388a37c5df53548201c15a4.jpg";